import { getInstitutionByIdQuery } from '@data/sanity/queries/institution'
import { SanityIdQueryParameter } from '@data/sanity/queries/types/parameters'
import { SanityInstitutionByIdQuery } from '@data/sanity/queries/types/institution'
import { fetchQuery } from './client'

/**
 * Fetches an institution by its ID.
 */
export const getInstitutionById = async (id: string) =>
  fetchQuery<SanityInstitutionByIdQuery, SanityIdQueryParameter>(
    getInstitutionByIdQuery,
    {
      id,
    },
  )
